<template>
<div class="tw-flex-none tw-flex tw-fixed tw-inset-y-0 tw-left-0 tw-w-full tw-z-[9999] lg:tw-z-0 lg:tw-w-auto lg:tw-block lg:tw-static" 
:class="[display ? 'tw-bg-gray-500 tw-bg-opacity-50 tw-pointer-events-auto' : 'tw-pointer-events-none lg:tw-pointer-events-auto']">
    <div :class="{'slide-in':!display}" class="tw-pointer-events-auto slide-out lg:tw-max-w-none tw-h-full" ref="sidebar">
        <slot></slot>
    </div>

    <div v-show="display" class="lg:tw-hidden">
        <div class="tw-pointer-events-auto tw-bg-gray-700 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-m-2 hover:tw-bg-gray-800" style="width: 40px; height: 40px;">
            <i class="fa fa-times tw-text-white"></i>
        </div>
    </div>

    <portal to="admin-toggle">
        <div @click="display = true" ref="trigger" class="tw-border-r tw-border-gray-300 tw-text-gray-700 tw-flex tw-justify-center tw-items-center lg:tw-hidden" style="width: 40px; height: 40px;">
            <i class="fa fa-chevron-circle-right tw-text-xl"></i>
        </div>
    </portal>
</div>
</template>

<script>
export default {
    name: "AdminSidebar",

    data() {
        return {
            display: false
        }
    },

    mounted() {
        document.addEventListener('click', event => {
            if(!this.$refs.sidebar.contains(event.target) && !this.$refs.trigger.contains(event.target)) {
                this.display = false;
            }
        });
    },

    methods: {

    }
}
</script>

<style scoped>
    .slide-out {
        max-width: 100vw;
        overflow: hidden;
        transition: max-width;
        -moz-transition-duration: 0.5s;
        -webkit-transition-duration: 0.5s;
        -o-transition-duration: 0.5s;
        transition-duration: 0.5s;
    }

    .slide-in {
        max-width: 0 !important;
    }

    @media (min-width: 992px) { 
        .slide-out {
            overflow: visible;
        }

        .slide-in {
            max-width: none !important;
        }
    }
</style>